import { PostHog } from "posthog-js/react";

import { User, UserDetailedInfo } from "@/types";
import { calculateAge } from "@/utils";

export const initializePosthog = (posthog: PostHog, user: User & UserDetailedInfo) => {
  posthog.identify(user.id, {
    email: user.email,
    role: user.role,
    name: `${user.firstName} ${user.lastName}`,
    age: calculateAge(user.dateOfBirth),
    status: user.status,
  });
};
